const  projectsNode = [
    {
       proTitle: "Node projects", 
       projectProps: [
        {
            title: "yt-v-props-getter",
            img: "./img_projects/Node/project1.png",
            desc: "Riceve informazioni relative al video in base all'URL passato.",
            long_desc: `In base all'url passata riceve informazioni relative ad un determinato file video.
            <p>Cattura informazioni relative alle playlist, la playlist con un numero d'elementi maggiori di cento, sará valutata fino al centesimo elemento.</p>`,
            topics: "Node, ES6, Express, axios, ASYNC/AWAIT, JSON",
            location_url: "https://node-yt-video-props-getter.onrender.com",
            source_code: false
        },
        // {
        //     title: "node-yt-video-props-getter",
        //     img: "./img_projects/Node/project1.png",
        //     desc: "Receives information relating to the video based on the URL passed.",
        //     long_desc: `Based on the URL passed, it receives information relating to a specific video file.
        //     <p>Capture playlist information, the playlist with a number of items greater than one hundred will be evaluated up to the hundredth item.</p>`,
        //     topics: "Node, ES6, Express, JSON",
        //     location_url: "https://github.com/pippo-github/php_downloader_4_ways",
        //     source_code: true
        // },
        ]
    }
]

export {projectsNode}
